<div class="stage">
    
    <section class="intro" id="slide0">
        <div class="intro-content">
            <h1 class="logo-wrap"><div class="logo">{{ pageName }}</div></h1>
            <p class="intro-content-txt" i18n>9 lat na rynku Marka Martz powstała w 2015 roku i od tego czasu zdobywa coraz większy udział na europejskich rynkach przyczep samochodowych. </p>
        </div>
        <picture>
            <source srcset="/assets/about/about-img1.webp" type="image/webp">
            <img class="intro-img intro-img-1" src="/assets/about/about-img1.jpg">
        </picture>
        <picture>
            <source srcset="/assets/about/about-img2.webp" type="image/webp">
            <img class="intro-img intro-img-2" src="/assets/about/about-img2.jpg">
        </picture>
        <a href="#slide1" class="scroll-link scroll-link-intro"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>
    
    <section class="slide flx-dynamic" id="slide1">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content slide-content--1">
                <h2 class="slide-content-title flx-col"><span class="line-inner small" i18n>martz</span><span class="line-inner" i18n>Sprawdzona jakość</span></h2>
                <div class="slide-content-wrap">
                    <p class="content-txt" i18n>Do produkcji wykorzystujemy najlepsze materiały, markowe podzespoły oraz nowoczesne maszyny, co zapewnia wytrzymałość przyczep, a klientom spokój na lata.</p>
                </div>
                <div class="flx-dynamic flx-gap-default">
                    <button class="flat-button primary" [routerLink]="['/'+path_offer]" i18n>Zobacz nasz produkty</button>
                </div>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img1.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img1.jpg">
                </picture>
            </div>
        </div>
        <a href="#slide2" class="scroll-link"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>   
    
    <section class="slide flx-dynamic" id="slide2">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content slide-content--2">
                <h2 class="slide-content-title flx-col"><span class="line-inner small" i18n>Nasza marka</span><br /><span class="line-inner" i18n>Na drogach Europy</span></h2>
                <div class="slide-content-wrap">
                    <p class="content-txt" i18n>Przyczepy Martz można spotkać w każdym zakątku Europy. Współpracujemy z dystrybutorami w ponad 30 krajach.</p>
                </div>
                <a class="flat-button accent" [routerLink]="['/'+path_dealers]" i18n>Poznaj naszych dealerów</a>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img2.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img2.jpg">
                </picture>
            </div>
        </div>
        <a href="#slide3" class="scroll-link"><svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg></a>
    </section>    
    
    <section class="slide flx-dynamic" id="slide3">
        <div class="w-50 slide-content-col-wrap">
            <div class="slide-content slide-content--2">
                <h2 class="slide-content-title flx-col"><span class="line-inner small" i18n>Nagrody</span><br /><span class="line-inner" i18n>Diament za dynamikę</span></h2>
                <div class="slide-content-wrap">
                    <p class="content-txt" i18n>Firma Martz została wyróżniona nagrodą Diament Forbes 2024 za wysoką dynamikę rozwoju w ciągu ostatnich trzech lat. Jesteśmy częścią UNITRAILER HOLDING.</p>
                </div>
                <a class="flat-button primary" i18n href="https://unitrailerholding.com" target="_blank">Odwiedź stronę UNITRAILER HOLDING</a>
            </div>
        </div>
        <div class="w-50 slide-img-col-wrap">
            <div class="image-wrap">
                <picture>
                    <source srcset="/assets/about/about-img3.webp" type="image/webp">
                    <img class="img" src="/assets/about/about-img3.jpg">
                </picture>
            </div>
        </div>
        <a href="#slide0" class="scroll-link"><svg class="icon icon-chevron-up"><use xlink:href="#icon-chevron-up"></use></svg></a>
    </section>
</div>